<template>
    <div>
        <title>总数</title>
        <article class="cardArticle">
            <header class="tabHeader">
                <p>
                    <router-link :to="{path:'/OperateRecord'}" class="isActive" v-if="openStoreDefinition==1">定义激活记录</router-link>
                    <router-link :to="{path:'/ActivationRecord'}" >激活记录</router-link>
                    <router-link :to="{path:'/PauseRecord'}" >暂停记录</router-link>
                    <router-link :to="{path:'/ReuseRecord'}" >恢复记录</router-link>
                    <router-link :to="{path:'/RecoverRecord'}" v-if="ElementControls('erjimendian')==1">销售回收记录</router-link>
                    <router-link :to="{path:'/SpreadRecordMd'}"  v-if="ElementControls('erjimendian')==1">铺券记录</router-link>
                </p>
            </header>
            <main class="cardMain">
                <div>
                    <ul class="flexBet totalHead">
                        <li :class="{'active':totalIndex == -1}"  @click="getTotalTab('-1')">
                            <strong>{{ cardBatchStatistics.totalnum }}</strong>
                            <em>总数</em>
                        </li>
                        <li :class="{'active':totalIndex == 0}"  @click="getTotalTab('0')" class="orangeColor">
                            <strong>{{ cardBatchStatistics.inactivenum }}</strong>
                            <em>未激活</em>
                        </li>
                        <li :class="{'active':totalIndex == 1}"  @click="getTotalTab('1')">
                            <strong>{{ cardBatchStatistics.activenum }}</strong>
                            <em>未提货</em>
                        </li>
                        <li :class="{'active':totalIndex == 2}"  @click="getTotalTab('2')">
                            <strong>{{ cardBatchStatistics.partpicknum }}</strong>
                            <em>部分提货</em>
                        </li>
                        <li :class="{'active':totalIndex == 3}"  @click="getTotalTab('3')">
                            <strong>{{ cardBatchStatistics.ypicknum }}</strong>
                            <em>已提货</em>
                        </li>
                        <li :class="{'active':totalIndex == 5}"  @click="getTotalTab('5')">
                            <strong>{{ cardBatchStatistics.yrecnum }}</strong>
                            <em>已回收</em>
                        </li>
                        <li :class="{'active':totalIndex == 7}"  @click="getTotalTab('7')">
                            <strong>{{ cardBatchStatistics.redefinenum }}</strong>
                            <em>重新出库</em>
                        </li>
                        <li :class="{'active':totalIndex == 4}"  @click="getTotalTab('4')">
                            <strong>{{ cardBatchStatistics.suspennum }}</strong>
                            <em>暂停使用</em>
                        </li>
                        <li :class="{'active':totalIndex == 6}"  @click="getTotalTab('6')">
                            <strong>{{ cardBatchStatistics.yzfnum }}</strong>
                            <em>已作废</em>
                        </li>
                        <li v-if="menus" :class="{'active':totalIndex == 8}"  @click="getTotalTab('8')">
                            <strong>{{ cardBatchStatistics.hszxnum }}</strong>
                            <em>回收折现</em>
                        </li>
                    </ul>
                    <!-- S 检索 -->
                    <el-form :model="totalForm" :inline="true" class="searchForm totalForm">
                        <el-form-item label="券卡编码" class="codeSerIpt">
                            <el-input clearable v-model="totalForm.code" placeholder="请输入券卡编码"></el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="totalForm.state" placeholder="请选择" clearable>
                                <el-option label="未激活" value="0"></el-option>
                                <el-option label="未提货" value="1"></el-option>
                                <el-option label="部分提货" value="2"></el-option>
                                <el-option label="已提货" value="3"></el-option>
                                <el-option label="已回收" value="5"></el-option>
                                <el-option label="重新出库" value="7"></el-option>
                                <el-option label="已暂停使用" value="4"></el-option>
                                <el-option label="已作废" value="6"></el-option>
                                <el-option v-if="menus" label="回收折现" value="8"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="query">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" plain @click="goBack">返回</el-button>
                        </el-form-item>
                        <template v-if="shownum">
                            <p class="greyColor totalMsg" v-if="totalIndex==-1&&(Number(batchNum)-Number(cardBatchStatistics.totalnum))==0">
                              <i class="iconbulb"></i>已有<b class="commonNum">{{Number(batchNum)-Number(pageTotal)}}</b>张券卡被重新出库或者回收再次出库！
                            </p>
                          </template>
                        <p class="greyColor totalMsg" v-if="totalIndex==-1&&(Number(batchNum)-Number(cardBatchStatistics.totalnum))>0">
                            <i class="iconbulb"></i>已有<b class="commonNum">{{(Number(batchNum) - Number(cardBatchStatistics.totalnum))|| '0'}}</b>张券卡被重新进行后续分销操作，请切换至后续分销记录列表查看！
                        </p>
                    </el-form>
                    <!-- E 检索 -->
                </div>
                <section class="totalCon">
                    <!-- S 表格 -->
                    <el-table ref="gsTable" class="comTable totalTable" border v-loading="vloading" :data="cardBatchCodeList" :maxHeight="tableHeight">
                        <el-table-column fixed label="序号" type="index"></el-table-column>
                        <el-table-column label="券卡编码" fixed width="200" prop="code">
                            <template slot-scope="scope">
                                <p>{{scope.row.code ||'--'}}</p>
                                <em v-if="scope.row.serial">【{{scope.row.serial||'--'}}】</em>
                            </template>
                        </el-table-column>
                        <el-table-column :label="statetype" width="120" fixed prop="state">
                            <template slot-scope="scope">
                                <span class="orangeColor" v-if="scope.row.state == 0 || scope.row.state == 1">{{scope.row.state | cardStateFilter}}</span>
                                <span class="greenColor" v-else-if="scope.row.state == 2 || scope.row.state == 5 || scope.row.state == 7">{{scope.row.state | cardStateFilter}}</span>
                                <span class="redColor" v-else-if="scope.row.state == 4 || scope.row.state == 6">{{scope.row.state | cardStateFilter}}</span>
                                <span class="blueColor" v-else-if="scope.row.state == 3">{{scope.row.state | cardStateFilter}}</span>
                                <span class="greyColor" v-else>{{scope.row.state | cardStateFilter}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="付款状态" width="120" fixed prop="paystate">
                            <template slot-scope="scope">
                                {{scope.row.paystatus | cardPpayStateFilter}}
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡类型" width="100">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.cardkind">{{scope.row.cardkind ||'--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="定义类型" width="200">
                            <template slot-scope="scope">
                                {{scope.row.deftype | cardTypeFilter}}
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡流向" width="150">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.lflowname">{{scope.row.lflowname || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="专区数量" sortable min-width="100" prop="selzones">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.selzones||'--'}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="共可选择商品数" sortable prop="selnum" min-width="200">
                            <template slot-scope="scope">
                                <p class="flexUpDownCenter">
                                    <template v-if="scope.row.cardcategory===0">
                                        <span class="priceFont pr10" >{{scope.row.goodspicknum|| '--'}}</span>
                                        <el-tag type="danger" plain>定量组合提货卡</el-tag>
                                    </template>
                                    <template v-else-if="scope.row.cardcategory===1">
                                        <span class="priceFont pr10" >{{scope.row.goodspicknum|| '--'}}</span>
                                        <el-tag  type="warning" plain>套餐组合提货卡</el-tag>
                                    </template>
                                    <template v-else-if="scope.row.cardcategory===2">
                                        <span class="priceFont pr10" >{{scope.row.goodspicknum|| '--'}}</span>
                                        <el-tag  type="success" plain>定额组合提货卡</el-tag>
                                    </template>
                                    <template v-else>
                                        <span class="priceFont pr10" >{{scope.row.selnum|| '--'}}</span>
                                    </template>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column label="可使用次数" sortable width="120" prop="usenum">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.usenum || '0'}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="默认商品" min-width="200">
                            <template slot-scope="scope">
                                <p class="textHiden" v-if="String(scope.row.cardcategory)>=0">--</p>
                                <p class="textHiden" v-else :title="scope.row.defaultgoodsname">{{scope.row.defaultgoodsname || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column :label="ElementControls('Quota_Pickupcard')==1?'券卡面值/额度(￥)':'券卡面值(￥)'" min-width="170">
                             <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.cardprice | formatAmount}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡售价 (￥)" sortable width="130" prop="cardsmallprice">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.cardsmallprice | formatAmount}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="有效期" width="120">
                            <template slot-scope="scope">
                                 <p class="serial" v-if="scope.row.startvaldate">
                                      {{dateTime(scope.row.startvaldate)}}
                                    <em>~</em>
                                      {{dateTime(scope.row.endvaldate)}}
                                </p>
                                <p class="serial" v-else>
                                      长期有效
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column label="客服备注" width="200">
                            <template slot-scope="scope">
                                <p class="textHiden left" :title="scope.row.sermemo">{{scope.row.sermemo || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="面单打印备注" width="200">
                            <template slot-scope="scope">
                                <p class="textHiden left" :title="scope.row.printmemo">{{scope.row.printmemo || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="90" fixed="right" prop="operate">
                            <template slot-scope="scope">
                                <a @click="getCoverDetailShow(scope.row)" class="icondetails" title="详情"></a>
                            </template>
                        </el-table-column>
                        <template slot="empty">
                          <div class="noData"><span>暂无数据</span></div>
                        </template>
                    </el-table>
                    <!-- E 表格 -->
                </section>
                <!-- S 出库详情弹框 -->
                <OutDetail :cardInfo="cardInfo" :outDetailDialogVisible="outDetailDialogVisible"  @closeChild="getCloseOutDetailCld"></OutDetail>
                <!-- E 出库详情弹框 -->
                <!-- S 分页 -->
                  <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
                <!-- E 分页 -->
            </main>
        </article>
        
    </div>
</template>
<script>
import Api from "@/apis/api.js";
import { mapState, mapActions } from "vuex";
export default {
    name:'CardRecordTotal',
    components: {
      Page: resolve => require(["@/components/common/Page.vue"], resolve),//分页
      OutDetail: resolve => require(["@/components/CardsFolder/OutDetail.vue"], resolve),//出库详情弹框
    },
    filters:{
        // 券卡当前状态
        stateFilter(val){
            if(val == 0){
                return '未激活'
            }else if(val == 1){
                return '未提货'
            }else if(val == 2){
                return '部分提货'
            }else if(val == 3){
                return '已提货'
            }else if(val == 4){
                return '已回收'
            }else if(val == 5){
                return '重新出库'
            }else if(val == 6){
                return '已暂停使用'
            }else if(val == 7){
                return '已作废'
            }
        }
    },
    data(){
        return{
            shownum:true,
            vloading:false,
            openStoreDefinition:0,
			      cardqupd:0,
            menus:false,
            statetype:'当前状态',
            cardInfo:'',
            batchcode:'',
            pageTotal:0, //总数
            currentPage:1, // 页数
            pageSize:30, // 条数
            cardBatchStatistics:'',
            cardBatchCodeList:[],
            // 检索表单
            totalForm:{
                code:'',//关键词
                state:'',//状态
            },
            // 表格数据
            recordData:[{
                serial:'aa005837',
                code:'9998573969214505',
                state:0
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:1
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:2
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:3
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:4
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:5
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:6
              },{
                  serial:'aa005837',
                  code:'9998573969214505',
                  state:7
            }],
            outDetailDialogVisible:false,//出库详情弹框
            totalIndex:-1,//当前选中总数
            totalData:[
                {
                    num:10,
                    totalText:'总数'
                },{
                    num:1,
                    totalText:'未激活'
                },{
                    num:1,
                    totalText:'未提货'
                },{
                    num:1,
                    totalText:'部分提货'
                },{
                    num:1,
                    totalText:'已提货'
                },{
                    num:1,
                    totalText:'已回收'
                },{
                    num:1,
                    totalText:'重新出库'
                },{
                    num:1,
                    totalText:'已暂停使用'
                },{
                    num:1,
                    totalText:'已作废'
                }
            ],
            tableHeight: window.innerHeight*.8, //表格动态高度
            batchNum: 0, // 批次内券卡总数 ---2020/06/17
        }
    },
    // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
    watch: {
      "totalForm.state":function(val){
        if(val=='5'){
              this.statetype = '回收前状态';
            } else if(val=='7'){
              this.statetype = '重新出库时状态';
            }else {
               this.statetype = '当前状态';
            }
             this.pageSize =30;
             this.currentPage =1;
            // this.getCardBatchCodeList();
      }
    },
    // ==================================== 方法 ====================================
    methods:{
        //查询
        query(){
          this.pageSize =30;
          this.currentPage =1;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchCodeList();
        },
        // 分页
        nowPageParam(val,vals){
          this.pageSize = val;
          this.currentPage = vals;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchCodeList();
        },
        // 打开出库详情弹框
        getCoverDetailShow(code){
            this.cardInfo =code;
            this.outDetailDialogVisible = true;
            // Api.GET_CARDINFODET({code:code,opertype:0}).then(res =>{
            //    if(res.data.status=="200"){
            //       if(res.data.data.codeinfo){
            //         this.cardInfo = res.data.data.codeinfo;
            //         this.outDetailDialogVisible = true;
            //       }
            //    }
            // })
        },
        // 关闭出库详情弹框
        getCloseOutDetailCld(){
            this.outDetailDialogVisible = false;
        },
        // 切换各种状态
        getTotalTab(totalIndex){
            if(totalIndex=='5'){
              this.statetype = '回收前状态';
            } else if(totalIndex=='7'){
              this.statetype = '重新出库时状态';
            }else {
               this.statetype = '当前状态';
            }
            this.totalIndex = totalIndex;
            if(totalIndex==-1){
              this.totalForm.state = '';
            }else{
              this.totalForm.state = totalIndex;
            }
            this.pageSize = 30;
            this.currentPage = 1;
            this.totalForm.code ='';
            this.getCardBatchCodeList();
        },
        // 返回上一页
        goBack(){
            window.history.back();   
        },
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
            this.tableHeight = window.innerHeight - tbHeight - 125; 
        },
        // 数量使用情况
        getCardBatchStatistics(){
           let param = {
              batchcode:this.batchcode,
              opertype:0
            }
          Api.GET_CARDBATCHSTATISTICS(param).then(res =>{
            if(res.data.status=="200"){
              this.cardBatchStatistics = res.data.data;
            }else{
              this.cardBatchStatistics= '';
            }
          })
        },
        // 批次内编码详情列表
        getCardBatchCodeList(){
           let param = {
               batchcode:this.batchcode,
               opertype:0,
               code:this.totalForm.code,
               state:this.totalForm.state,
               pageparam:{
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
                }
           }
           this.vloading = true;
           if(this.totalForm.code===''&&this.totalForm.state===''){
            this.shownum = true
          }else{
            this.shownum = false
          }
          Api.GET_CARDBATCHCODELIST(param).then(res =>{
              this.toTableTop('gsTable');
             if(res.data.status=="200"){
                 this.vloading = false;
                 this.cardBatchCodeList = res.data.data;
                 this.pageTotal = res.data.pagebean.totalnum;
              }else {
                 this.vloading = false;
                 this.pageTotal =0;
                 this.cardBatchCodeList =[];
              }
          })
        },
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    mounted () {
      this.openStoreDefinition = this.ElementControls('openStoreDefinition')
		  this.cardqupd =this.ElementControls('cardqupd')
      if(localStorage.getItem('menus')&&localStorage.getItem('menus')!='null'){
          this.menus = JSON.parse(localStorage.getItem('menus')).includes('HSZXGL02');
      }
        if(this.$route.query.batchcode){
          this.batchcode = this.$route.query.batchcode;
          this.getCardBatchCodeList();
          this.getCardBatchStatistics();
        }
        // 2020/06/17 券卡批次传递过来的总数
        if(this.$route.query.batchNum) {
            this.batchNum = this.$route.query.batchNum;
        }
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)
    },
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
.cardArticle{
    position: relative;
    padding: 84px 20px 20px 20px;
    height: calc(100% - 169px);
}
/* S 头部数量统计 */
.totalHead{
    width: 100%;
    height: 100px;
    background: #F5F7FA;
} 
.totalHead li{
    position: relative;
    text-align: center;
    width: calc(100%/10);
    cursor: pointer;
}
.totalHead li::after{
    content: '';
    position: absolute;
    width: 1px;
    height: 60px;
    background: #DCDFE6;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 0;
}
.totalHead li:last-child::after{
    display: none;
}
.totalHead li strong{
    color: #333;
    font-size: 28px;
    font-family: "PingFang SC", "Microsoft YaHei", Arial, Verdana;
} 
.totalHead li em{
    color: #666;
    display: block;
    margin-top: 5px;
} 
.totalHead .active strong{
    font-weight: bold;
}
/* E 头部数量统计 */
/* S 检索 */
.totalMsg{
    font-size: 12px;
    display: inline-block;
    line-height: 40px;
    border: none;
    width: auto;
}
.totalMsg i{
    color: #F2962C;
    font-size: 16px;
    margin-right: 5px;
}
.totalMsg b{
    color: #F7615E;
    font-weight: bold;
    margin: 0 3px;
    font-size: 14px;
}
.totalForm{
    margin: 20px 0;
}
.totalForm>>>.el-form-item{margin-bottom: 0!important;}
/* E 检索 */
/* S 表格 */
.totalTable tr:last-child td{
    border-bottom: none;
}
.totalTable>>>th:last-child .cell,
.totalTable>>>td:last-child .cell,
.totalTable>>>th:first-child .cell,
.totalTable>>>td:first-child .cell{
    text-align: center;
}
.totalTable>>>.el-table__fixed-right-patch{
    background-color: #F5F7FA;
}
.serial em{
    display: block;
    margin-left: 26px;
}
.totalTable .icondetails{
    font-size: 18px;
}
/* E 表格 */
</style>


// WEBPACK FOOTER //
// src/views/CardsFolder/CardsGift/CardRecord/CardRecordTotal.vue